export function breachServiceActive(breachService: any) {
    if (breachService && breachService.isBreachClarityInCatalog && breachService.isBreachClarityServiceActive) {
        return true;
    }
    return false;
}

export function breachScoreBetween(val: number) {
    if (val >= 1 && val <= 29) {
        return 1;
    } else if (val >= 30 && val <= 69) {
        return 4;
    } else if (val >= 70 && val <= 100) {
        return 7;
    } else {
        return 1;
    }
}
export function breachSafetyScoreBetween(val: number) {
    if (val >= 0 && val <= 49) {
        return 1;
    } else if (val >= 50 && val <= 89) {
        return 4;
    } else if (val >= 90 && val <= 100) {
        return 7;
    } else {
        return 1;
    }
}
